import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function goStoreStart(business) {
  pushClevertapEvent('GoStore Start', {
    'Business ID': business.id,
    'Business Name': business.name,
    'Business Category': business.category,
    'Business Province': business.province,
    'Business City': business.city,
    'Business Phone Number': business.phone,
    'Business Email': business.email,
    'Business Owner name': business.full_name,
  });
}

export function goStoreLaunch(business) {
  pushClevertapEvent('GoStore Launch', {
    'Business ID': business.id,
    'Business Name': business.name,
    'Business Category': business.category,
    'Business Province': business.province,
    'Business City': business.city,
    'Business Phone Number': business.phone,
    'Business Email': business.email,
    'Business Owner name': business.full_name,
  });
}
